<template>
    <BreadCrumb :items="breadcrumbItems" />
    <main id="main">
        <InquiryCreateForm/>
    </main>
</template>
<script>
import InquiryCreateForm from '@/components/customerService/InquiryCreateForm.vue';
import BreadCrumb from '../layout/navigation/BreadCrumb.vue';

export default {
    data() {
        return {
            breadcrumbItems: [
                { href: "/", text: "홈", isHome: true },
                { href: "#", text: "고객센터" },
            ],
        };
    },
    components: {
        InquiryCreateForm,
        BreadCrumb
    }
}
</script>
<style lang="">
    
</style>